import { render, staticRenderFns } from "./ImportTasks.vue?vue&type=template&id=97ea244c&scoped=true"
import script from "./ImportTasks.vue?vue&type=script&lang=js"
export * from "./ImportTasks.vue?vue&type=script&lang=js"
import style0 from "./ImportTasks.vue?vue&type=style&index=0&id=97ea244c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ea244c",
  null
  
)

export default component.exports